import React, { useEffect, useState } from "react";
import useApi from "../utils/useApi";
import "../css/User.css";
import { useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import ic_no_data from "../img/ic_no_data.svg";
import "../css/toggle_switch.css";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import ic_user from "../img/ic_user.png";
import UserRightsSetting from "./UserRightsSetting";

function DepartmentRightsSetting() {
  const COMPANY_CODE = localStorage.getItem("companyCode") || "-";
  const [updatedDepartmentRights, setUpdatedDepartmentRights] = useState(null);

  const {
    data: datagetgetDepartmentList,
    loading: loadinggetDepartmentList,
    get: getDepartmentList,
  } = useApi();

  const {
    data: datapostUpdateDepartmentRights,
    post: postUpdateDepartmentRights,
  } = useApi();

  const query = new URLSearchParams(useLocation().search);
  const user_name = query.get("user_name");

  // 1. Unified order change handler
  const handleOrderChange = (codeFromClick, value) => {
    setUpdatedDepartmentRights((prev) =>
      prev?.map((item) => {
        if (item.Deptno === codeFromClick) {
          return { ...item, ordord_Id: value };
        }
        return item;
      })
    );
  };

  // 2. Clearer toggle switch logic
  const handleChangeSwitch = (codeFromClick, currentStatus) => {
    setUpdatedDepartmentRights((prev) =>
      prev?.map((item) => {
        if (item.Deptno === codeFromClick) {
          return {
            ...item,
            AccessStatus: currentStatus === "T" ? "F" : "T",
          };
        }
        return item;
      })
    );
  };

  // Fetch initial data
  useEffect(() => {
    if (user_name) {
      getDepartmentList(
        `https://cubixweberp.com:213/api/CpaysCount/${COMPANY_CODE}/DEPTACCESSUSER/${encodeURIComponent(user_name)}/-`
      );
    }
  }, [user_name]);

  // 3. Map the incoming API property & SANITIZE trailing whitespaces
  useEffect(() => {
    if (datagetgetDepartmentList) {
      setUpdatedDepartmentRights(
        datagetgetDepartmentList.map((item) => {
          // Trim out string spaces so <input type="number" /> reads it cleanly
          const cleanOrdId = item.ord_id && typeof item.ord_id === "string"
            ? item.ord_id.trim()
            : item.ord_id;

          return {
            ...item,
            Deptno: item.Deptno?.trim() || "", // Cleans up "ALQ       " -> "ALQ"
            ordord_Id: cleanOrdId ?? "",       // Maps API's ord_id to your state's ordord_Id
            AccessStatus: item.AccessStatus?.trim() || "F"
          };
        })
      );
    }
  }, [datagetgetDepartmentList]);

  // Alert on success
  useEffect(() => {
    if (datapostUpdateDepartmentRights?.result?.trim()?.toUpperCase() === "SAVED") {
      alert("Updated Department rights");
    }
  }, [datapostUpdateDepartmentRights]);

  // 4. Construct payload using clean state keys
  const saveDepartmentRights = () => {
    if (!updatedDepartmentRights) return;

    const arraytoPass = updatedDepartmentRights
      .filter((item) => item.AccessStatus === "T")
      .map((item) => ({
        CMPCODE: COMPANY_CODE,
        MODE: "DEPTACCESS",
        A_USER: user_name,
        DEPTNO: item.Deptno,
        ordord_Id: item.ordord_Id, // Safely matches your state key
      }));

    console.log("Saving arraytoPass >> ", arraytoPass);

    postUpdateDepartmentRights(
      `https://cubixweberp.com:213/api/CRMDeptAccessUser`,
      JSON.stringify(arraytoPass),
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  return (
    <div>
      <div className="p-4">
        <h4>Department Access</h4>
        {updatedDepartmentRights && (
          <button
            className="bg-blue-100 text-blue-700 font-semibold rounded p-2 my-4"
            onClick={saveDepartmentRights}
          >
            Update Department Rights
          </button>
        )}
      </div>

      {datagetgetDepartmentList?.length === 0 && !loadinggetDepartmentList ? (
        <div className="p-4">
          <img style={{ width: "100px" }} src={ic_no_data} alt="No Data" />
          <p className="mt-3">No data found</p>
        </div>
      ) : (
        <div className="overflow-x-auto mt-2" style={{ height: "50vh", overflowY: "scroll" }}>
          <table
            className="min-w-full divide-y divide-gray-200 border border-gray-300"
            style={{ borderCollapse: "collapse" }}
          >
            <thead>
              <tr className="bg-gray-100" style={{ position: "sticky", top: "0px", zIndex: 3 }}>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Has Access</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Order</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Deptno</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Description</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {updatedDepartmentRights?.map((item) => (
                <tr key={item.Deptno} className="hover:bg-gray-50">
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    <FormControlLabel
                      control={<Switch checked={item.AccessStatus === "T"} />}
                      label={item.AccessStatus === "T" ? "On" : "Off"}
                      onChange={() => handleChangeSwitch(item.Deptno, item.AccessStatus)}
                    />
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    <input
                      type="number"
                      min="1"
                      step="1"
                      value={item.ordord_Id}
                      onChange={(e) => handleOrderChange(item.Deptno, e.target.value)}
                      className="w-16 px-2 py-1 border border-gray-300 rounded text-sm text-center"
                    />
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.Deptno}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.Description}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default DepartmentRightsSetting;